import { render } from "./ShipmentList_item_icons.vue?vue&type=template&id=4c10352e&scoped=true"
import script from "./ShipmentList_item_icons.vue?vue&type=script&lang=js"
export * from "./ShipmentList_item_icons.vue?vue&type=script&lang=js"

import "./ShipmentList_item_icons.vue?vue&type=style&index=0&id=4c10352e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c10352e"]])

export default __exports__